import React, { PureComponent } from 'react';
import AboutMe from './components/AboutMe.jsx';
import WorkExprience from './components/WorkExprience.jsx';
import Skills from './components/Skills.jsx';
import Education from './components/Education.jsx';
import Organization from './components/Organization.jsx';

import 'bootstrap/dist/css/bootstrap.css';
import './App.scss';
const rootClass = 'app';
class App extends PureComponent {
  componentDidMount() {
    this.props.getResume();
  }
  render() {
    const { contact, name, objective, title, workExprience,  education, skills, organizations , isLoaded} = this.props.resume;
    if(!isLoaded) {
      return null;
    }
    return (
      <div className={`container ${rootClass}`}>
        <section className={`${rootClass}__about-me`}>
          <AboutMe contact={contact} name={name} objective={objective} title={title} />
        </section>
        <div className={`${rootClass}__section`}>
            <section className={`${rootClass}__section__exprience`}>
              <section data-role="WorkExprience">
                <WorkExprience workExprience={workExprience} />
              </section>
            </section>
            <div className={`${rootClass}__section__skills`}>
              <section data-role="skills">
                <Skills skills={skills} />
              </section>
              <section data-role="organization">
                <Organization organizations={organizations} />
              </section>
              
              <section data-role="education">
                  <Education education={education} />
                </section>
            </div>
        </div>
      </div>
    );
  }
}

export default App;
